import { getAnalyticsPaymentMethodTypeFromMedium } from '../machines/helpers';
import { AutopayStatusEnum } from '../typings/analytics';
import useApiMachine from './machines/useApiMachine';
const useAnalyticsAutopayValues = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [apiMachine] = useApiMachine();
    const { autopayStatusQueryResult, paymentEnterpriseEligibilityQueryResult } = apiMachine.context;
    const autopayStatus = autopayStatusQueryResult.data.enrollment
        ? AutopayStatusEnum.ENROLLED
        : AutopayStatusEnum.UNENROLLED;
    const nextDueDate = (_a = autopayStatusQueryResult.data.enrollmentDetails) === null || _a === void 0 ? void 0 : _a.nextDueDate;
    const autopayEnrollmentEligibility = (_b = paymentEnterpriseEligibilityQueryResult.data.AUTOPAY) === null || _b === void 0 ? void 0 : _b.find((eligibility) => eligibility.subEligibilityType === 'AUTOPAY_ENROLL');
    const effectiveDueDate = (_d = (_c = autopayEnrollmentEligibility.criteria) === null || _c === void 0 ? void 0 : _c.find(({ attribute }) => attribute === 'effectiveDueDate')) === null || _d === void 0 ? void 0 : _d.value;
    const paymentFrom = ((_e = autopayStatusQueryResult === null || autopayStatusQueryResult === void 0 ? void 0 : autopayStatusQueryResult.data.paymentMethod // typings on syf-api-library missed the cardNumberLast4 property. Tempral casting is used.
    ) === null || _e === void 0 ? void 0 : _e.cardNumberLast4) ||
        ((_f = autopayStatusQueryResult === null || autopayStatusQueryResult === void 0 ? void 0 : autopayStatusQueryResult.data.paymentMethod) === null || _f === void 0 ? void 0 : _f.bankAccountNumberLast4);
    const paymentMethodType = getAnalyticsPaymentMethodTypeFromMedium(autopayStatusQueryResult.data.paymentMethod);
    return {
        autopayStatus,
        effectiveDueDate,
        nextDueDate,
        paymentMethodType,
        paymentFrom,
        paymentOption: (_h = (_g = autopayStatusQueryResult.data.enrollmentDetails) === null || _g === void 0 ? void 0 : _g.paymentOption) === null || _h === void 0 ? void 0 : _h.toLowerCase()
    };
};
export default useAnalyticsAutopayValues;
